export const DEAL_TEMPLATE_KEY_DEAL_CONTACT: string = 'dealContact';
export const DEAL_TEMPLATE_KEY_SPONSOR: string = 'sponsor';
export const DEAL_TEMPLATE_KEY_BROKER: string = 'broker';
export const DEAL_TEMPLATE_KEY_LENDER: string = 'lender';
export const DEAL_TEMPLATE_KEY_DEAL_STRUCTURE: string = 'dealStructure';
export const DEAL_TEMPLATE_KEY_LOT_SIZE: string = 'lotSize';
export const DEAL_TEMPLATE_KEY_DEAL_TERM: string = 'dealTerm';
export const DEAL_TEMPLATE_KEY_AMOUNT: string = 'amount';
export const DEAL_TEMPLATE_KEY_PROJECTED_NOI_AMOUNT: string = 'projectedNoiAmount';
export const DEAL_TEMPLATE_KEY_APPRAISED_VALUE_AMOUNT: string = 'appraisedValueAmount';
export const DEAL_TEMPLATE_KEY_LOAN_AMOUNT: string = 'loanAmount';
export const DEAL_TEMPLATE_KEY_RFP: string = 'rfp';
export const DEAL_TEMPLATE_KEY_ESTIMATED_TDC: string = 'estimatedTdc';
export const DEAL_TEMPLATE_KEY_EQUITY_REQUIRED: string = 'equityRequired';
export const DEAL_TEMPLATE_KEY_ASKING_PRICE: string = 'askingPrice';
export const DEAL_TEMPLATE_KEY_LOAN_TYPE: string = 'loanType';
export const DEAL_TEMPLATE_KEY_EXTENSION_CONDITIONS: string = 'extensionConditions';
export const DEAL_TEMPLATE_KEY_EQUITY_AMOUNT: string = 'equityAmount';
export const DEAL_TEMPLATE_KEY_TOTAL_FUNDED: string = 'totalFunded';
export const DEAL_TEMPLATE_KEY_TOTAL_UNFUNDED: string = 'totalUnfunded';
export const DEAL_TEMPLATE_KEY_DEAL_INVESTMENT_RETURNS: string = 'dealInvestmentReturns';
export const DEAL_TEMPLATE_KEY_DEAL_CAPITALIZATION: string = 'dealCapitalization';
export const DEAL_TEMPLATE_KEY_DEAL_BUILDING_DETAILS_ASSET_USE_BREAKDOWN: string
  = 'dealBuildingDetailsAssetUseBreakdown';
export const DEAL_TEMPLATE_KEY_DEAL_OVERVIEW: string = 'dealOverview';
export const DEAL_TEMPLATE_KEY_DEAL_PHOTOS: string = 'dealPhotos';
export const DEAL_TEMPLATE_KEY_DEAL_ALLOCATION: string = 'dealAllocation';
export const DEAL_TEMPLATE_KEY_DEAL_MILESTONES: string = 'dealMilestones';
export const DEAL_TEMPLATE_KEY_DEAL_EXTERNAL_LINKS: string = 'dealExternalLinks';
export const DEAL_TEMPLATE_KEY_DEAL_CONTACTS: string = 'dealContacts';
export const DEAL_TEMPLATE_KEY_DEAL_FILES: string = 'dealFiles';

export const DEAL_TEMPLATE_KEY_LIST: string[] = [
  DEAL_TEMPLATE_KEY_DEAL_CONTACT,
  DEAL_TEMPLATE_KEY_SPONSOR,
  DEAL_TEMPLATE_KEY_BROKER,
  DEAL_TEMPLATE_KEY_LENDER,
  DEAL_TEMPLATE_KEY_DEAL_STRUCTURE,
  DEAL_TEMPLATE_KEY_LOT_SIZE,
  DEAL_TEMPLATE_KEY_DEAL_TERM,
  DEAL_TEMPLATE_KEY_AMOUNT,
  DEAL_TEMPLATE_KEY_PROJECTED_NOI_AMOUNT,
  DEAL_TEMPLATE_KEY_APPRAISED_VALUE_AMOUNT,
  DEAL_TEMPLATE_KEY_LOAN_AMOUNT,
  DEAL_TEMPLATE_KEY_RFP,
  DEAL_TEMPLATE_KEY_ESTIMATED_TDC,
  DEAL_TEMPLATE_KEY_EQUITY_REQUIRED,
  DEAL_TEMPLATE_KEY_ASKING_PRICE,
  DEAL_TEMPLATE_KEY_LOAN_TYPE,
  DEAL_TEMPLATE_KEY_EXTENSION_CONDITIONS,
  DEAL_TEMPLATE_KEY_EQUITY_AMOUNT,
  DEAL_TEMPLATE_KEY_TOTAL_FUNDED,
  DEAL_TEMPLATE_KEY_TOTAL_UNFUNDED,
  DEAL_TEMPLATE_KEY_DEAL_INVESTMENT_RETURNS,
  DEAL_TEMPLATE_KEY_DEAL_CAPITALIZATION,
  DEAL_TEMPLATE_KEY_DEAL_BUILDING_DETAILS_ASSET_USE_BREAKDOWN,
  DEAL_TEMPLATE_KEY_DEAL_OVERVIEW,
  DEAL_TEMPLATE_KEY_DEAL_PHOTOS,
  DEAL_TEMPLATE_KEY_DEAL_ALLOCATION,
  DEAL_TEMPLATE_KEY_DEAL_MILESTONES,
  DEAL_TEMPLATE_KEY_DEAL_EXTERNAL_LINKS,
  DEAL_TEMPLATE_KEY_DEAL_CONTACTS,
  DEAL_TEMPLATE_KEY_DEAL_FILES,
];
